export const TaskStatus = Object.freeze({
    NOPROGRESS: 1,
    INPROGRESS: 2,
    COMPLETED: 3,
});
